<template>
 <div class="line-item"> 
      <div class="heading ml-2" style="display:flex;">
        <v-icon title="At Sea">mdi-waves</v-icon>
        <v-btn class="adminLibelleBtn"  :to="{name:'EditGlider',params:{itemid:item.id}}" flat :title="$t('Admin.Glider.List.ReachGliderTooltip')" >           
          {{item.GLI_KEY}} <span class="font-italic" v-if="item.GLI_KEY != item.GLI_LIBELLE">({{item.GLI_LIBELLE}})</span>
        </v-btn>              
      </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { AloDbGlider } from '@/models/alodb/AloDbGlider';


@Component({
  name: 'AdminGliderListLine',   
   props: {  
     item:{
       type:AloDbGlider,
       required:true
     }  
  }
})
export default class AdminGliderListLine extends Vue {
  item!:AloDbGlider
  
  
}
</script>